// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-chapter-name,
.header-book-name {
  width: 50%;
  padding-left: 10%;
  padding-right: 10%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 30px;
  text-align: center;
  opacity: 0.3;
  float: left;
}
.header-container,
.footer-container {
  width: 100%;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}
.header-container {
  position: absolute;
  top: 13px;
}
.footer-container {
  position: absolute;
  bottom: 14px;
}

.background-page-left,
.background-page-right {
  width: 50%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 30px;
  text-align: center;
  opacity: 0.3;
  float: left;
}
.footer-time {
  letter-spacing: 0.5px;
  position: absolute;
  top: 6px;
  left: 20px;
  font-size: 13px;
  opacity: 0.5;
}
.bookmark {
  height: 40px;
  width: 20px;
  padding: 0px;
  transform: rotate(0deg) skew(0deg);
  border-left: 10px solid red;
  border-right: 10px solid red;
  border-bottom: 10px solid transparent;
  position: fixed;
  top: 5px;
  right: 70px;
  z-index: 15;
}
.bookmark,
.bookmark:before,
.bookmark:after {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.background {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  z-index: -10;
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-border {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 4px solid #e74c3c;
  pointer-events: none;
  box-sizing: border-box;
  z-index: 1;
  margin: 5px;
}
.inner-page-border {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #e74c3c;
  pointer-events: none;
  box-sizing: border-box;
  z-index: 1;
  margin: 15px;
}
.page-border-header-line {
  position: absolute;
  top: 37px;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #e74c3c;
  pointer-events: none;
  z-index: 1;
  margin-left: 15px;
  margin-right: 15px;
}
.page-border-footer-line {
  position: absolute;
  bottom: 37px;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #e74c3c;
  pointer-events: none;
  z-index: 1;
  margin-left: 15px;
  margin-right: 15px;
}
.page-border-center-line {
  position: absolute;
  top: 37px;
  bottom: 37px;
  left: 50%;
  width: 1px;
  background-color: #e74c3c;
  pointer-events: none;
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/containers/pageWidget/background.css"],"names":[],"mappings":"AAAA;;EAEE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EAEZ,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;EACrC,eAAe;EACf,QAAQ;EACR,WAAW;EACX,WAAW;AACb;AACA;;;EAGE,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;AACZ","sourcesContent":[".header-chapter-name,\n.header-book-name {\n  width: 50%;\n  padding-left: 10%;\n  padding-right: 10%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  line-height: 30px;\n  text-align: center;\n  opacity: 0.3;\n  float: left;\n}\n.header-container,\n.footer-container {\n  width: 100%;\n  height: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n}\n.header-container {\n  position: absolute;\n  top: 13px;\n}\n.footer-container {\n  position: absolute;\n  bottom: 14px;\n}\n\n.background-page-left,\n.background-page-right {\n  width: 50%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  line-height: 30px;\n  text-align: center;\n  opacity: 0.3;\n  float: left;\n}\n.footer-time {\n  letter-spacing: 0.5px;\n  position: absolute;\n  top: 6px;\n  left: 20px;\n  font-size: 13px;\n  opacity: 0.5;\n}\n.bookmark {\n  height: 40px;\n  width: 20px;\n  padding: 0px;\n  -webkit-transform: rotate(0deg) skew(0deg);\n  transform: rotate(0deg) skew(0deg);\n  border-left: 10px solid red;\n  border-right: 10px solid red;\n  border-bottom: 10px solid transparent;\n  position: fixed;\n  top: 5px;\n  right: 70px;\n  z-index: 15;\n}\n.bookmark,\n.bookmark:before,\n.bookmark:after {\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n}\n.background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: -10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.page-border {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 4px solid #e74c3c;\n  pointer-events: none;\n  box-sizing: border-box;\n  z-index: 1;\n  margin: 5px;\n}\n.inner-page-border {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 1px solid #e74c3c;\n  pointer-events: none;\n  box-sizing: border-box;\n  z-index: 1;\n  margin: 15px;\n}\n.page-border-header-line {\n  position: absolute;\n  top: 37px;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #e74c3c;\n  pointer-events: none;\n  z-index: 1;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n.page-border-footer-line {\n  position: absolute;\n  bottom: 37px;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #e74c3c;\n  pointer-events: none;\n  z-index: 1;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n.page-border-center-line {\n  position: absolute;\n  top: 37px;\n  bottom: 37px;\n  left: 50%;\n  width: 1px;\n  background-color: #e74c3c;\n  pointer-events: none;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
